<template>

  <div :id="page_slug">

    <div class="crumbs-bar">
      <el-row>
        <el-col :span="12">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ name: 'DashboardPage' }">Dashboard</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ name: 'CategoryGroupList' }">Category Groups</el-breadcrumb-item>
            <el-breadcrumb-item>Edit</el-breadcrumb-item>
          </el-breadcrumb>        
        </el-col>      
      </el-row>
    </div>

    <el-tabs @tab-click="handleClick" type="card" v-model="active_tab">
      <el-tab-pane label="Details" name="details">
        <el-form
          ref="category_group"
          :rules="rules.category_group"
          :model="category_group"
          :label-position="label_position">

          <el-form-item label="Name" prop="name">
            <el-input v-model="category_group.name"></el-input>
          </el-form-item>

          <el-form-item label="Sort Order" prop="sort_order">
            <el-input-number controls-position="right" :min="0" v-model="category_group.sort_order"></el-input-number>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="updateCategoryGroup('category_group')">Update</el-button>
          </el-form-item>

        </el-form>
      </el-tab-pane>

      <el-tab-pane label="Assign Categories" name="assign_categories">
        <el-card 
          hover="never"
          :body-style="{ padding: '0px' }">
          <div slot="header" class="clearfix">
            <el-row>
              <el-col :span="16">
                <el-input
                style="width: 35%;"
                :clearable="true"
                placeholder="Filter Categories"
                prefix-icon="el-icon-search"
                v-model="filter_product_categories"></el-input>
              </el-col>

              <el-col :span="6" :offset="2" class="text-right">
                <el-button @click="assignCategories()">Assign Categories</el-button>
              </el-col>
            </el-row>
          </div>

          <div class="scroll-pane">
            <el-checkbox-group v-model="selected_product_categories">
              <el-checkbox v-for="item in filteredCategories" :label="item.id" :key="item.id" class="checkbox-list">{{item.name}}</el-checkbox>
            </el-checkbox-group>
          </div>
        </el-card>
      </el-tab-pane>

    </el-tabs>

    <pre v-if="config.debug">{{$data}}</pre>

  </div>

</template>

<style scoped>

  .checkbox-list {
    display:block;
    margin: 0 0 5px 0;
    padding: 0;
  }

  ul.sync-list {
    padding:0;
    margin:0;
    list-style: none;
  }

  ul.sync-list li {
    margin:10px 0 10px 0;
  }

  .button_card {
    text-align: center;
    margin-top: 20px;
  }

</style>

<script>

  import Config from '@/store/Config.js';

  export default {
    data: function() {
      return {
        page_alias: 'Add Product Category Group',
        page_slug: 'add-product-category-group',
        label_position: 'top',
        active_tab: 'details',

        config: Config.config,
        
        loading: {
          category_group: true,
          product_categories: false
        },
        
        category_group: {
          id: '',
          name: '',
          thumbnail_url: '',
          sort_order: '',
        },

        product_categories: [],
        selected_product_categories: [], 
        filter_product_categories: '',

        rules: {
          category_group: {
            name: [
              { required: true, message: 'Please Enter Name', trigger: 'blur' }
            ],
            sort_order: [
              { required: true, message: 'Please Enter Sort Order', trigger: 'blur' },
            ]
          }
        }
      };  
    },

    mounted: function() {
      const me = this;

      /* CALLS FOR FIRST TAB PANE */
      me.getCategoryGroup();

      /* CALLS FOR SECOND TAB PANE */
      me.getProductCategories();
      me.getAssignedCategories()
    },

    computed: {
      filteredCategories() {
        const me = this;
        return me.product_categories.filter(function(e){return e.name.toLowerCase().indexOf(me.filter_product_categories.toLowerCase())>=0;});
      }
    },

    methods: {
      /* METHODS FOR FIRST TAB PANE */
      getCategoryGroup: function() {
        console.log('Get Category Group Function');
        const me = this;

        me.loading.category_group = true;

        me.$http.get(me.config.api + 'category-group/{id}', {params: {id : me.$route.params.id}}).then(
          response => {
          console.log('Get Category Group Function - Success Getting Data')  

          me.category_group = response.body.data;

          me.loading.category_group = false;
        }, response => {
          console.log('Get Category Group Function - Error Getting Data');

          me.$notify({
            title: 'Error',
            message: response.statusText,
            stype: 'error'
          });

          me.loading = false;
        });
      },

      updateCategoryGroup: function(form_name) {
        console.log('Update Category Group Function');
        const me = this;

        me.$refs[form_name].validate((valid) => {
          if(valid) {
            me.loading.category_group = true;

            me.$http.put(me.config.api + 'category-group/{id}', me.category_group, {params: {id : me.$route.params.id}}).then(
              response => {
              console.log('Update Category Group Function - Success Putting Data')  

              me.getCategoryGroup();

              me.$notify({
                title: 'Success',
                message: 'The Category Group Was Updated',
                type: 'success'
              });
            }, response => {
              console.log('Update Category Group Function - Error Putting Data');

              me.loading.category_group = false;
            });
          } else {
            console.log('Fields Not Valid');
            return false;
          }
        });   
      },
      /* END METHODS FOR FIRST TAB PANE */

      /* METHODS FOR SECOND TAB PANE */
      getProductCategories: function(goToPage) {
        console.log('Get Product Categories Function');
        const me = this;

        me.loading.product_categories = true;

        me.$http.get(me.config.api + 'productCategory').then(
          response => {
          console.log('Get Product Categories Function - Success Getting Data')  

          me.product_categories = response.body.data;

          me.loading.product_categories = false;
          }, response => {
            console.log('Get Product Categories Function - Error Getting Data');

            me.$notify({
              title: 'Error',
              message: response.statusText,
              type: 'error'
            });

            me.loading.product_categories = false;
          }
        );
      },

      getAssignedCategories: function() {
        console.log('Get Assigned Categories Function');
        const me = this;

        me.$http.get(me.config.api + 'category-group/{id}/category', {params: {id: me.$route.params.id}}).then(
          response => {
          console.log('Get Assigned Categories Function - Success Getting Data')  

          var data = response.body.data;
          me.selected_product_categories = data.map(a => a.id);
        }, response => {
          console.log('Get Assigned Categories Function - Error Getting Data');

          me.$notify({
            title: 'Error',
            message: response.statusText,
            type: 'error'
          });
        });
      },

      assignCategories: function() {
        const me = this;
        console.log('Assign Categories Function');

        me.$http.post(me.config.api + 'category-group/{id}/category', me.selected_product_categories, {params: {id: me.$route.params.id}}).then(
          response => {
          console.log('Assign Categories Function - Success Posting Data');  

          me.getAssignedCategories();

          me.filter_product_categories = '';

          me.$notify({
            title: 'Success',
            message: 'This Categories Were Assigned',
            type: 'success'
          });                
        }, response => {
          console.log('Error Posting Data');
        });
      },
      /* END METHODS FOR FIRST TAB PANE */

      handleClick: function() {
        console.log('Handle Click Function');
        const me = this;

        if(me.active_tab == 'details') {
          //me.getCategoryGroup();
        } else if(me.active_tab == 'assign_categories') {
          //me.getProductCategories();
        }
      },

      resetForm(form_name) {
        const me = this;
        this.$refs[form_name].resetFields();
      } //LAST METHOD
    } //END METHODS
  }
</script>


// WEBPACK FOOTER //
// src/pages/product-category-groups/CategoryGroupEdit.vue